export default "__VITE_ASSET__Dqe4V1pp__"